// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "InsightAI",
    appLogoImage: require("@src/assets/images/logo/logo_final.png").default
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "hidden", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "sticky" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button,
    toastPosition: "top-right", // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right,
    hideNavBar: false,
    showInfoLoader: false
  }
};

export default themeConfig;
